import { render } from "./CameraOverlay.vue?vue&type=template&id=2ab6c67e&scoped=true"
import script from "./CameraOverlay.vue?vue&type=script&lang=js"
export * from "./CameraOverlay.vue?vue&type=script&lang=js"

import "./CameraOverlay.vue?vue&type=style&index=0&id=2ab6c67e&lang=scss&scoped=true"

import exportComponent from "/Users/saschas/dev/neurocure_website/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab6c67e"]])

export default __exports__